import React, { FormEvent, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import useApi from '../../../hooks/useApi'
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton'
import TextareaInput from '../../../Korbantech/components/Inputs/TextareaInput'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../../Korbantech/components/Label'
import { Diagnosis } from '../../../types/Diagnosis'
import { DataChecks } from '../../OscForm/OscInputs/DataChecks'

export const NameAndDescription = ({ diagnosis }: Props) => {
    const api = useApi()
    const navigate = useNavigate()

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        if (!diagnosis) return
        const data = new FormData(e.currentTarget)

        data.append('_method', 'PATCH')
        return await api.post(`/admin/diagnoses/${diagnosis.id}`, data).then(res => {
            window.location.reload()
            navigate("/admin/")
        }).catch(console.log)

    }, [api, navigate, diagnosis])

    return (
        <>
            {diagnosis ?
                <form onSubmit={handleSubmit} className='flex flex-col'>
                    <Label className="font-bold text-lg">
                        Dê um nome para o teste
                        <TextInput name={'name'} required
                            defaultValue={diagnosis && diagnosis.name}
                            className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} />
                    </Label>
                    <Label className="font-bold text-lg">
                        Descrição do teste
                        <TextareaInput required name={"description"} rows='7'
                            defaultValue={diagnosis && diagnosis.description}
                            className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2 h-48'} />
                    </Label>
                    <DataChecks unique={true} data={[{id:"gestão",name:"Gestão"},{id:"comunicação",name:"Comunicação"}]} label={"Categoria"}
                        name={"category"}
                        select={diagnosis && diagnosis.category}
                    />
                    <div className='w-5/12 self-end'>
                        <SubmitButton className={'col-span-1'} value={'Salvar Alteração'} />
                    </div>
                </form>
                :
                <div>
                    <Label className="font-bold text-lg">
                        Dê um nome para o teste
                        <TextInput required name={'name'}
                            className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} />
                    </Label>
                    <Label className="font-bold text-lg">
                        Descrição do teste
                        <TextareaInput required name={"description"} rows='7'
                            className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2 h-48'} />
                    </Label>
                    <DataChecks unique={true} data={[{id:"gestão",name:"Gestão"},{id:"comunicaçao",name:"Comunicação"}]} label={"Categoria"}
                        name={"category"}
                        select={""}
                    />
                </div>
            }
        </>
    )
}

interface Props {
    diagnosis?: Diagnosis
}
